import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty, map } from 'lodash';

import AddAnotherBarber from '../containers/AddAnotherBarber';
import Icon, { GLYPHS } from '../../../common/icon';
import Money from '../../../common/money';
import OrderInfoDiscountItem from '../containers/OrderInfoDiscountItem';
import OrderInfoItem from '../containers/OrderInfoItem';
import { taxBreakdownArray } from './shapes';
import MembershipCartItem from '../../memberships/MembershipCartItem';

const OrderInfo = ({
  barbers,
  discounts,
  taxAmount,
  resetOrder,
  taxBreakdown,
  membershipDiscounts,
  membership,
  resetMembership,
}) => (
  <div className="u-pb u-pt-">
    <div className="o-flexbox o-flexbox--content-align-center u-ph u-pb-">
      <span className="u-flex-1">Current Sale</span>
      <button
        type="button"
        className="c-btn c-btn--blank u--mr-"
        onClick={resetOrder}
      >
        <Icon glyph={GLYPHS.refresh} size="medium" />
      </button>
    </div>
    {barbers.map(id =>
      <OrderInfoItem
        key={id}
        barberId={id}
      />
    )}
    <AddAnotherBarber />
    <MembershipCartItem
      membership={membership}
      resetMembership={resetMembership}
      display-if={membership}
    />
    <div
      className="c-order-item o-flexbox u-co-dark-gray u-type--normal"
      display-if={taxAmount && taxBreakdown.length === 1}
    >
      <span className="u-flex-1">Sales Tax</span>
      <Money>{taxAmount}</Money>
    </div>
    {taxBreakdown.length > 1 && map(taxBreakdown, tax => (
      <div
        className="c-order-item o-flexbox u-co-dark-gray u-type--normal"
        key={tax.taxId}
      >
        <span className="u-flex-1">{tax.name}</span>
        <Money>{tax.amount}</Money>
      </div>
    ))}
    <div display-if={!isEmpty(discounts)}>
      {discounts.map(id => <OrderInfoDiscountItem key={id} id={id} />)}
    </div>
    <div display-if={!isEmpty(membershipDiscounts)}>
      {membershipDiscounts.map(id => <OrderInfoDiscountItem key={id} id={id} />)}
    </div>
  </div>
);

OrderInfo.propTypes = {
  barbers: PropTypes.arrayOf(PropTypes.string),
  discounts: PropTypes.arrayOf(PropTypes.string).isRequired,
  membershipDiscounts: PropTypes.arrayOf(PropTypes.string).isRequired,
  taxAmount: PropTypes.number,
  resetOrder: PropTypes.func.isRequired,
  taxBreakdown: taxBreakdownArray,
  membership: PropTypes.object,
  resetMembership: PropTypes.func.isRequired,
};
OrderInfo.defaultProps = {
  barbers: [],
  taxAmount: 0,
  taxBreakdown: [],
  membership: null,
};

export default OrderInfo;
